import React, { useState } from "react";
import client from "../api/client";
import { getLang } from "../store/uiStore";
import "./ChangePassword.css";

export default function ChangePassword() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const lang = getLang();

  const tr = {
    title: lang === "ru" ? "Смена пароля" : "Иваз кардани парол",
    subtitle:
      lang === "ru"
        ? "Измените пароль для защиты вашей учётной записи."
        : "Барои ҳифзи ҳисоби корбарии худ паролро иваз кунед.",
    oldPassword: lang === "ru" ? "Текущий пароль" : "Пароли ҷорӣ",
    newPassword: lang === "ru" ? "Новый пароль" : "Пароли нав",
    confirmPassword:
      lang === "ru"
        ? "Подтверждение нового пароля"
        : "Тасдиқи пароли нав",
    save: lang === "ru" ? "Сохранить" : "Сабт кардан",
    successDefault:
      lang === "ru" ? "Пароль успешно изменён." : "Парол бомуваффақият иваз карда шуд.",
    errorDefault: lang === "ru" ? "Ошибка" : "Хатогӣ",
    show: lang === "ru" ? "Показать пароль" : "Намоиши парол",
    hide: lang === "ru" ? "Скрыть пароль" : "Пинҳон кардани парол",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");
    setError("");

    try {
      const res = await client.post("/api/change-password/", {
        old_password: oldPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
      });

      setMessage(res.data.detail || tr.successDefault);

      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      setError(
        err.response?.data?.detail || tr.errorDefault
      );
    }
  };

  const PasswordToggle = ({ visible, onClick }) => (
    <button
      type="button"
      className="nizom-password-toggle"
      onClick={onClick}
      aria-label={visible ? tr.hide : tr.show}
      title={visible ? tr.hide : tr.show}
    >
      {visible ? (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M3 3l18 18"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M10.6 5.1A11.8 11.8 0 0 1 12 5c5.2 0 8.7 4.3 9.8 6-.5.8-1.6 2.2-3.2 3.5M6.3 6.4C4.3 7.6 2.8 9.6 2.2 11c1.1 1.7 4.6 6 9.8 6 1.2 0 2.3-.2 3.3-.6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.9 9.9a3 3 0 0 0 4.2 4.2"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M2.2 12S5.7 6 12 6s9.8 6 9.8 6-3.5 6-9.8 6-9.8-6-9.8-6z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <circle
            cx="12"
            cy="12"
            r="3"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
          />
        </svg>
      )}
    </button>
  );

  return (
    <main className="nizom-change-password-page">
      <div className="nizom-change-password-container">
        <section className="nizom-change-password-card">
          <header className="nizom-change-password-header">
            <div className="nizom-change-password-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <rect
                  x="5"
                  y="10"
                  width="14"
                  height="10"
                  rx="2"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                />
                <path
                  d="M8 10V7.5a4 4 0 0 1 8 0V10"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />
                <circle cx="12" cy="15" r="1.2" fill="currentColor" />
              </svg>
            </div>

            <div>
              <h1>{tr.title}</h1>
              <p>{tr.subtitle}</p>
            </div>
          </header>

          <form onSubmit={handleSubmit} className="nizom-change-password-form">
            <div className="nizom-password-field">
              <label htmlFor="old-password">
                {tr.oldPassword}
                <span>*</span>
              </label>

              <div className="nizom-password-input-wrap">
                <input
                  id="old-password"
                  type={showOld ? "text" : "password"}
                  placeholder={tr.oldPassword}
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  autoComplete="current-password"
                />
                <PasswordToggle
                  visible={showOld}
                  onClick={() => setShowOld((value) => !value)}
                />
              </div>
            </div>

            <div className="nizom-password-field">
              <label htmlFor="new-password">
                {tr.newPassword}
                <span>*</span>
              </label>

              <div className="nizom-password-input-wrap">
                <input
                  id="new-password"
                  type={showNew ? "text" : "password"}
                  placeholder={tr.newPassword}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  autoComplete="new-password"
                />
                <PasswordToggle
                  visible={showNew}
                  onClick={() => setShowNew((value) => !value)}
                />
              </div>
            </div>

            <div className="nizom-password-field">
              <label htmlFor="confirm-password">
                {tr.confirmPassword}
                <span>*</span>
              </label>

              <div className="nizom-password-input-wrap">
                <input
                  id="confirm-password"
                  type={showConfirm ? "text" : "password"}
                  placeholder={tr.confirmPassword}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  autoComplete="new-password"
                />
                <PasswordToggle
                  visible={showConfirm}
                  onClick={() => setShowConfirm((value) => !value)}
                />
              </div>
            </div>

            {message && (
              <div className="nizom-change-password-message success" role="status">
                <span className="nizom-message-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path
                      d="M5 12.5l4.2 4.2L19 7"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span>{message}</span>
              </div>
            )}

            {error && (
              <div className="nizom-change-password-message error" role="alert">
                <span className="nizom-message-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <circle
                      cx="12"
                      cy="12"
                      r="9"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    />
                    <path
                      d="M12 7v6M12 16.5v.1"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
                <span>{error}</span>
              </div>
            )}

            <button type="submit" className="nizom-change-password-submit">
              {tr.save}
            </button>
          </form>
        </section>
      </div>
    </main>
  );
}
